import React from 'react';
import { Link } from 'react-router-dom';
import {
  Segment,
} from 'semantic-ui-react';

export default function ViewOnly(props) {
  const {
    dealer,
    salesperson,
  } = props;

  if (!dealer) {
    return (
      <Segment padded>
        <h2>No Dealer!</h2>
      </Segment>
    );
  }

  return (
    <Segment padded textAlign="center">
      <h2 style={{ marginBottom: '5px' }}>
        <Link target="_blank" to={`/admin/dealers/${dealer.id}`}>{dealer.name}</Link>
      </h2>
      <p style={{ fontSize: '1.25em' }}>
        {dealer.company_name} (Company)<br />
        {dealer.phone}<br />
        {dealer.email}<br />
        {dealer.address_1 ? `${dealer.address_1},` : ''} {dealer.city ? `${dealer.city},` : ''} {dealer.state}
      </p>
      {
        salesperson &&
          <p style={{ fontSize: '1.25em' }}>
            <b>
              <Link target="blank" to={`/admin/salespeople/${salesperson.id}`}>
                {salesperson.first_name} {salesperson.last_name} -  Salesperson
              </Link>
            </b><br />
            {salesperson.phone}<br />
            {salesperson.email}<br />
          </p>
      }
    </Segment>
  );
}